import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "inventory-page" };
const _hoisted_2 = { class: "page-header" };
const _hoisted_3 = { class: "header-actions" };
const _hoisted_4 = ["disabled"];
const _hoisted_5 = { class: "table-toolbar" };
const _hoisted_6 = { class: "search-box" };
const _hoisted_7 = { class: "item-count" };
const _hoisted_8 = {
    key: 0,
    class: "notice error-notice",
    role: "alert"
};
const _hoisted_9 = {
    key: 1,
    class: "notice"
};
const _hoisted_10 = {
    key: 2,
    class: "table-frame"
};
const _hoisted_11 = { class: "inventory-table" };
const _hoisted_12 = { class: "check-column" };
const _hoisted_13 = ["checked"];
const _hoisted_14 = { class: "check-column" };
const _hoisted_15 = ["value", "aria-label"];
const _hoisted_16 = { class: "product-name" };
const _hoisted_17 = { class: "numeric" };
const _hoisted_18 = { class: "numeric" };
const _hoisted_19 = { class: "row-actions" };
const _hoisted_20 = ["aria-label", "onClick"];
const _hoisted_21 = ["aria-label", "onClick"];
const _hoisted_22 = { key: 0 };
const _hoisted_23 = {
    class: "empty-state",
    colspan: "10"
};
const _hoisted_24 = { class: "inventory-footer" };
const _hoisted_25 = { class: "form-header" };
const _hoisted_26 = { class: "form-grid" };
const _hoisted_27 = { class: "form-field" };
const _hoisted_28 = { class: "form-field" };
const _hoisted_29 = { class: "form-field" };
const _hoisted_30 = { class: "form-field" };
const _hoisted_31 = { class: "form-field" };
const _hoisted_32 = { class: "form-field" };
const _hoisted_33 = { class: "form-field" };
const _hoisted_34 = { class: "form-field" };
const _hoisted_35 = {
    key: 0,
    class: "notice error-notice",
    role: "alert"
};
const _hoisted_36 = { class: "form-actions" };
const _hoisted_37 = ["disabled"];
const _hoisted_38 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Download = _resolveComponent("Download");
    const _component_Plus = _resolveComponent("Plus");
    const _component_Search = _resolveComponent("Search");
    const _component_Pencil = _resolveComponent("Pencil");
    const _component_Trash2 = _resolveComponent("Trash2");
    const _component_X = _resolveComponent("X");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
            _cache[19] || (_cache[19] = _createElementVNode("div", null, [
                _createElementVNode("p", { class: "eyebrow" }, "STOCK CONTROL"),
                _createElementVNode("h1", null, "Inventory")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    class: "primary-button export-button",
                    type: "button",
                    disabled: _ctx.loading || _ctx.filteredProducts.length === 0,
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.exportInventoryPdf && _ctx.exportInventoryPdf(...args)))
                }, [
                    _createVNode(_component_Download, {
                        size: 17,
                        "aria-hidden": "true"
                    }),
                    _cache[17] || (_cache[17] = _createElementVNode("span", null, "Export PDF", -1))
                ], 8, _hoisted_4),
                _createElementVNode("button", {
                    class: "primary-button",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.openCreateForm && _ctx.openCreateForm(...args)))
                }, [
                    _createVNode(_component_Plus, {
                        size: 17,
                        "aria-hidden": "true"
                    }),
                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "Add New", -1))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
                _createVNode(_component_Search, {
                    size: 17,
                    "aria-hidden": "true"
                }),
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.searchText) = $event)),
                    type: "search",
                    placeholder: "Search inventory",
                    "aria-label": "Search inventory"
                }, null, 512), [
                    [_vModelText, _ctx.searchText]
                ])
            ]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.filteredProducts.length) + " items", 1)
        ]),
        (_ctx.pageError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.pageError), 1))
            : (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Loading inventory…"))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("table", _hoisted_11, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_12, [
                                    _createElementVNode("input", {
                                        type: "checkbox",
                                        "aria-label": "Select all products",
                                        checked: _ctx.allSelected,
                                        onChange: _cache[3] || (_cache[3] =
                                            //@ts-ignore
                                            (...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
                                    }, null, 40, _hoisted_13)
                                ]),
                                _cache[20] || (_cache[20] = _createElementVNode("th", null, "Name", -1)),
                                _cache[21] || (_cache[21] = _createElementVNode("th", null, "Internal SKU", -1)),
                                _cache[22] || (_cache[22] = _createElementVNode("th", null, "Supplier SKU", -1)),
                                _cache[23] || (_cache[23] = _createElementVNode("th", null, "Supplier(s)", -1)),
                                _cache[24] || (_cache[24] = _createElementVNode("th", { class: "numeric" }, "Regular Price", -1)),
                                _cache[25] || (_cache[25] = _createElementVNode("th", { class: "numeric" }, "Current Stock", -1)),
                                _cache[26] || (_cache[26] = _createElementVNode("th", { class: "numeric" }, "Low Stock Threshold", -1)),
                                _cache[27] || (_cache[27] = _createElementVNode("th", null, "Category", -1)),
                                _cache[28] || (_cache[28] = _createElementVNode("th", { class: "actions-heading" }, "Actions", -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (product) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: product.id
                                }, [
                                    _createElementVNode("td", _hoisted_14, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.selectedIds) = $event)),
                                            type: "checkbox",
                                            value: product.id,
                                            "aria-label": `Select ${product.name}`
                                        }, null, 8, _hoisted_15), [
                                            [_vModelCheckbox, _ctx.selectedIds]
                                        ])
                                    ]),
                                    _createElementVNode("td", _hoisted_16, _toDisplayString(product.name), 1),
                                    _createElementVNode("td", null, _toDisplayString(product.internalSku || '—'), 1),
                                    _createElementVNode("td", null, _toDisplayString(product.supplierSku || '—'), 1),
                                    _createElementVNode("td", null, _toDisplayString(product.suppliers.join(', ') || '—'), 1),
                                    _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatMoney(product.regularPrice)), 1),
                                    _createElementVNode("td", {
                                        class: _normalizeClass(["numeric", { 'low-stock': product.stock <= product.lowStockThreshold }])
                                    }, _toDisplayString(product.stock), 3),
                                    _createElementVNode("td", _hoisted_18, _toDisplayString(product.lowStockThreshold), 1),
                                    _createElementVNode("td", null, _toDisplayString(product.category || '—'), 1),
                                    _createElementVNode("td", _hoisted_19, [
                                        _createElementVNode("button", {
                                            class: "icon-button",
                                            type: "button",
                                            "aria-label": `Edit ${product.name}`,
                                            title: "Edit product",
                                            onClick: ($event) => (_ctx.openEditForm(product))
                                        }, [
                                            _createVNode(_component_Pencil, {
                                                size: 17,
                                                "aria-hidden": "true"
                                            })
                                        ], 8, _hoisted_20),
                                        _createElementVNode("button", {
                                            class: "icon-button danger-action",
                                            type: "button",
                                            "aria-label": `Delete ${product.name}`,
                                            title: "Delete product",
                                            onClick: ($event) => (_ctx.deleteProduct(product))
                                        }, [
                                            _createVNode(_component_Trash2, {
                                                size: 17,
                                                "aria-hidden": "true"
                                            })
                                        ], 8, _hoisted_21)
                                    ])
                                ]));
                            }), 128)),
                            (_ctx.filteredProducts.length === 0)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                                    _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.products.length ? 'No products match your search.' : 'No inventory products yet. Add your first product to get started.'), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])),
        _createElementVNode("footer", _hoisted_24, [
            _cache[29] || (_cache[29] = _createElementVNode("span", null, "Stock Value", -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.stockValue)), 1)
        ]),
        (_ctx.formOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "modal-backdrop",
                onClick: _cache[16] || (_cache[16] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.closeForm && _ctx.closeForm(...args)), ["self"]))
            }, [
                _createElementVNode("form", {
                    class: "product-form",
                    onSubmit: _cache[15] || (_cache[15] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.saveProduct && _ctx.saveProduct(...args)), ["prevent"]))
                }, [
                    _createElementVNode("header", _hoisted_25, [
                        _createElementVNode("div", null, [
                            _cache[30] || (_cache[30] = _createElementVNode("p", { class: "eyebrow" }, "PRODUCT DETAILS", -1)),
                            _createElementVNode("h2", null, _toDisplayString(_ctx.editingProduct ? 'Edit Product' : 'Add Inventory Product'), 1)
                        ]),
                        _createElementVNode("button", {
                            class: "icon-button close-button",
                            type: "button",
                            "aria-label": "Close form",
                            onClick: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                (...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                        }, [
                            _createVNode(_component_X, {
                                size: 19,
                                "aria-hidden": "true"
                            })
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("label", _hoisted_27, [
                            _cache[31] || (_cache[31] = _createElementVNode("span", null, "Product name", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.form.name) = $event)),
                                required: "",
                                maxlength: "120"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.name,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_28, [
                            _cache[32] || (_cache[32] = _createElementVNode("span", null, "Category", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.form.category) = $event)),
                                maxlength: "80"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.category,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_29, [
                            _cache[33] || (_cache[33] = _createElementVNode("span", null, "Internal SKU", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.form.internalSku) = $event)),
                                maxlength: "80"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.internalSku,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_30, [
                            _cache[34] || (_cache[34] = _createElementVNode("span", null, "Supplier SKU", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.form.supplierSku) = $event)),
                                maxlength: "80"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.supplierSku,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_31, [
                            _cache[35] || (_cache[35] = _createElementVNode("span", null, "Supplier(s), comma separated", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.form.suppliers) = $event)),
                                maxlength: "240"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.suppliers,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_32, [
                            _cache[36] || (_cache[36] = _createElementVNode("span", null, "Regular price (ZAR)", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.form.regularPrice) = $event)),
                                type: "number",
                                min: "0",
                                step: "0.01",
                                required: ""
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.regularPrice,
                                    void 0,
                                    { number: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_33, [
                            _cache[37] || (_cache[37] = _createElementVNode("span", null, "Current stock", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.form.stock) = $event)),
                                type: "number",
                                min: "0",
                                step: "1",
                                required: ""
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.stock,
                                    void 0,
                                    { number: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_34, [
                            _cache[38] || (_cache[38] = _createElementVNode("span", null, "Low stock threshold", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.form.lowStockThreshold) = $event)),
                                type: "number",
                                min: "0",
                                step: "1",
                                required: ""
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.lowStockThreshold,
                                    void 0,
                                    { number: true }
                                ]
                            ])
                        ])
                    ]),
                    (_ctx.formError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.formError), 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("footer", _hoisted_36, [
                        _createElementVNode("button", {
                            class: "secondary-button",
                            type: "button",
                            disabled: _ctx.saving,
                            onClick: _cache[14] || (_cache[14] =
                                //@ts-ignore
                                (...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                        }, "Cancel", 8, _hoisted_37),
                        _createElementVNode("button", {
                            class: "primary-button",
                            type: "submit",
                            disabled: _ctx.saving
                        }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.saving ? 'Saving…' : _ctx.editingProduct ? 'Save Changes' : 'Add Product'), 1)
                        ], 8, _hoisted_38)
                    ])
                ], 32)
            ]))
            : _createCommentVNode("", true)
    ]));
}
